import SepaCardIconSvg from './svg/sepaCard.svg?url';

export interface ISepaCardIconProps {
	size?: number;
}

export function SepaCardIcon({ size = 24 }: ISepaCardIconProps) {
	return (
		<img
			src={SepaCardIconSvg}
			alt="sepa card icon"
			width={size}
			height={size}
		/>
	);
}
